import { render, staticRenderFns } from "./qualityApprovalDetail.vue?vue&type=template&id=70ea1ead&scoped=true"
import script from "./qualityApprovalDetail.vue?vue&type=script&lang=js"
export * from "./qualityApprovalDetail.vue?vue&type=script&lang=js"
import style0 from "./qualityApprovalDetail.vue?vue&type=style&index=0&id=70ea1ead&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea1ead",
  null
  
)

export default component.exports